import { useState } from 'react';
import { FcGoogle } from 'react-icons/fc';
import { signInWithGoogleNative } from '../../utils/nativeSocialLogin';

// "Continuă cu Google" button shown ONLY inside the iOS app, in place of the
// web Google Identity Services button (which can't run in WKWebView). It runs
// the native Capacitor sign-in, then hands the returned Google ID token to
// `onCredential` — the same callback shape the web button feeds, so the page
// reuses its existing loginWithGoogle flow unchanged.
//
// A silent user-cancel (the native sheet's "Cancel") is swallowed; any real
// failure is surfaced via onError (visible banner) AND logged — so a broken
// sign-in never just "does nothing".
export default function NativeGoogleButton({ onCredential, onError, disabled }) {
  const [loading, setLoading] = useState(false);

  const handlePress = async () => {
    if (loading || disabled) return;
    setLoading(true);
    try {
      const idToken = await signInWithGoogleNative();
      await onCredential(idToken);
    } catch (err) {
      // Pull the most useful string out of whatever the plugin threw (Error,
      // bare string, or a {code,message} plugin object).
      let detail = typeof err === 'string' ? err : (err?.message || err?.errorMessage || err?.code || '');
      if (!detail) { try { detail = JSON.stringify(err); } catch { detail = String(err); } }
      // A deliberate user-cancel isn't an error — match loosely across plugin
      // versions and swallow it; everything else is shown + logged.
      if (!/cancel|dismiss|abort/i.test(detail)) {
        console.error('[NativeGoogle] sign-in failed:', detail || err);
        onError?.(detail || 'eroare necunoscută');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handlePress}
      disabled={loading || disabled}
      className="flex w-full items-center justify-center gap-3 rounded-xl border border-ink/15 bg-cream-50 px-4 py-3 text-sm font-semibold text-ink transition active:bg-cream-100 disabled:opacity-60"
    >
      <FcGoogle className="h-5 w-5" />
      {loading ? 'Se conectează…' : 'Continuă cu Google'}
    </button>
  );
}
